import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { track } from "@/lib/api";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import BottomNav from "@/components/layout/BottomNav";
import CookieBanner from "@/components/layout/CookieBanner";

export default function Layout() {
  const { pathname } = useLocation();
  const site = useSite();
  useEffect(() => { window.scrollTo(0, 0); track("view", pathname); }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <a href="#conteudo" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] bg-white px-4 py-3 rounded-lg shadow" data-testid="skip-link">Saltar para o conteúdo</a>
      <Header />
      <main id="conteudo" className="flex-1 pb-24 lg:pb-0" tabIndex={-1}>
        {site.data ? <Outlet /> : (
          <div className="container-x py-32 text-center" data-testid="site-loading" role="status">
            {site.error ? "Não foi possível carregar os conteúdos. Verifique a ligação e tente novamente." : "A carregar a Feira…"}
          </div>
        )}
      </main>
      <Footer />
      <BottomNav />
      <CookieBanner />
    </div>
  );
}
